export const SerieEntity = {
    id: null,
    tipoComprobante: null,
    serie: '',
    ultimoCorrelativo: 0,
    activo: true
};
